import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { CircularProgress, Grid, Typography, Alert, Button } from "@mui/material";
import moment from "moment";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import { timeConfig, dateConfig, SET_EMPTY } from "config";
import { getPunchesReportData, date, time } from "utils/report";
import { MY_TEAM, OTHER_TEAM, SPACE } from "config/CONSTANTS";
import { mkConfig, generateCsv, download} from "export-to-csv";
import { makeStyles } from "@material-ui/core/styles";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Link } from "react-router-dom";
import {
  ADD_EDIT_PUNCH_SUPERVISOR,
  SUPERVISOR_PTO,
  REPORT_DURATION,
  CONTRACTOR_TIMESHEET
} from "navigation/CONSTANTS";
import {
  INCOMPLETE_BG_INVALID,
  INCOMPLETE_BG_VALID,
} from "config";
import { PTO } from "config";
import { Card } from "@material-ui/core";
import { properCase, jobTypeITContractor } from "utils";
import { useDispatch } from "react-redux";
import {
  saveReportViewFilterList,
  selectedWeekOnReview,
} from "redux/actions/appActions";
import { udpatePunchStatus } from "utils/activity";
import { endOfWeek, startOfWeek } from "date-fns";
import { MaterialReactTable, useMaterialReactTable} from "material-react-table";
import NoData from "utils/NoData";

export const ReportView = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(SET_EMPTY);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const { reportViewFiltersData } = useSelector((state) => state.appConfig);
  const {approveForManager,selectedTeam,imtRole} = props;
  //console.log("------reportViewFiltersData-------",reportViewFiltersData);
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  const blank = properCase(t("pgReview.tableStaticText.blank"));
  useEffect(() => {
    setData([]);
    setIsLoading(true);
    setLoadingError(SET_EMPTY);
    if (user.workerId && !userLoading) {
      if (props.view === "Monthly") {
        let date = props.month ? props.month : new Date();
        date = date.setHours(0, 0, 0, 0);

        let userWorkerId = selectedTeam === OTHER_TEAM ? approveForManager.managerId : user.workerId

        getPunchesReportData(
          userWorkerId,
          moment(startOfMonth(date)).format(dateConfig.format4),
          moment(endOfMonth(date)).format(dateConfig.format4)
        )
          .then((data) => {
            if (data && data.length > 0) {

              console.log("viewDetails",data);

              let filterData = [...data]

            if(selectedTeam === OTHER_TEAM){
      
                  let delegateFor = user?.delegateFor;
                  if ((!(delegateFor && approveForManager &&
                    delegateFor.includes(approveForManager.managerId))) &&
      
                     ((imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor")
      
                      || (!imtRole && user.isApprover))) {
                        
                        filterData = filterData.filter(item => item.worker && 
                          item.worker.approvingManager && item.worker.approvingManager.includes(user.workerId) )
                      }
            }
    
              data = filterData.filter((item) => {
                return (
                  moment(item.outTS).isSameOrBefore(
                    moment(endOfMonth(date)),
                    "day"
                  ) &&
                  moment(item.outTS).isSameOrAfter(
                    moment(startOfMonth(date)),
                    "day"
                  )
                );
              });
              data = udpatePunchStatus(data);
              console.log("report data:", data);
              setData(data);
              setLoadingError(SET_EMPTY);
            } else {
              setLoadingError("pgReview.noPunchesToReport");
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            setLoadingError("pgReview.errLoadingWorkerList");
            console.error("ReportView: Err in getWorkerByMgr Response: ", err);
          });
      }
      if (props.view === "Weekly") {
        let date = props.week ? props.week : new Date();
        date = date.setHours(0, 0, 0, 0);
        let userWorkerId = selectedTeam === OTHER_TEAM ? approveForManager.managerId : user.workerId
        getPunchesReportData(
          userWorkerId,
          moment(startOfWeek(date)).format(dateConfig.format4),
          moment(endOfWeek(date)).format(dateConfig.format4)
        )
          .then((data) => {
            if (data && data.length > 0) {

              let filterData = [...data]

              if(selectedTeam === OTHER_TEAM){
        
                    let delegateFor = user?.delegateFor;
                    if ((!(delegateFor && approveForManager &&
                      delegateFor.includes(approveForManager.managerId))) &&
        
                       ((imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor")
        
                        || (!imtRole && user.isApprover))) {
                          
                          filterData = filterData.filter(item => item.worker && 
                            item.worker.approvingManager && item.worker.approvingManager.includes(user.workerId) )
                        }
                      }
      
              data = filterData.filter((item) => {
                return (
                  moment(item.outTS).isSameOrBefore(
                    moment(endOfWeek(date)),
                    "day"
                  ) &&
                  moment(item.outTS).isSameOrAfter(
                    moment(startOfWeek(date)),
                    "day"
                  )
                );
              });
              data = udpatePunchStatus(data);
              console.log("report data:", data);
              setData(data);
              setLoadingError(SET_EMPTY);
            } else {
              setLoadingError("pgReview.noPunchesToReport");
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            setLoadingError("pgReview.errLoadingWorkerList");
            console.error("ReportView: Err in getWorkerByMgr Response: ", err);
          });
      }
    } else if (userLoading) {
      console.log("Continue loading google user's data from IRM DB!");
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "ReportView: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
  }, [userLoading, props.month, props.week, props.view,approveForManager,selectedTeam]);

  const columns = [
    {
      accessorKey: "name",
      header: properCase(t("pgReview.tableHeads.name")),
      size: 70,
    },
    {
      accessorKey: "jobName",
      header: properCase(t("pgReview.tableHeads.jobFamily")),
      size: 70,
    },
    {
      accessorKey: "activityGroup",
      header: properCase(t("pgReview.tableHeads.activityGroup")),
      size: 70,
    },
    {
      header: properCase(t("pgReview.tableHeads.buildingId")),
      accessorKey: "buildingId",
      size: 70,
    },
    {
      header: properCase(t("pgReview.tableHeads.projectInfo")),
      accessorKey: "jobProjectInfo",
      size: 70,
    },
    {
      header: properCase(t("pgReview.tableHeads.exceptionType")),
      accessorKey: "exceptionName",
      size: 70,
    },
    {
      // Added to include the formatted start date in the downloaded csv
      header: properCase(t("pgReview.tableHeads.startDate")),
      accessorKey: "startDate",
      size: 70,
    },
    {
      // Added to include the formatted start time in the downloaded csv
      header: properCase(t("pgReview.tableHeads.startTime")),
      accessorKey: "startTime",
      size: 70,
      
    },
    {
      // Added to include the formatted end date in the downloaded csv
      header: properCase(t("pgReview.tableHeads.endDate")),
      accessorKey: "endDate",
      size: 70,
    },
    {
      // Added to include the formatted end time in the downloaded csv
      header: properCase(t("pgReview.tableHeads.endTime")),
      accessorKey: "endTime",
      size: 70,
    },
    {
      header: properCase(t("pgReview.tableHeads.duration")),
      accessorKey: "duration",
      size: 70,
    },
    {
      header: properCase(t("pgReview.tableHeads.status")),
      accessorKey: "status",
      size: 70,
        Cell:({renderedCellValue, row}) => {
          let dataIndex = row.index;
          const rowData = row.original;
          const {status, statusException, worker, editable} = rowData
            let pathDetails = {};
            if( worker && worker.jobType && worker.jobType == jobTypeITContractor){  
              pathDetails = {
                pathname : CONTRACTOR_TIMESHEET,
                state : {
                  worker:{...worker, name:worker?.firstName+SPACE+worker?.lastName}
                }
              }
            }else{
              pathDetails = {
                pathname: "/timesheet",
                state: {
                  punch: data[dataIndex],
                  selectedWorker: data[dataIndex]["worker"],
                  isReport: true,
                }
              }
            }
          console.log("editable:::", editable);
          let link = (
            <>
              {/* {(APPROVED_STATUS.toUpperCase() === status.toUpperCase() || statusException) ? status.toUpperCase() : ( // ENMO-949 to edit approved */}
              {statusException || editable === false ? (
                 status &&

                 status.toUpperCase() === "APPROVED" ?                   
                 properCase(t("pgReview.tableStaticText.approved")) :
                 
                 status.toUpperCase() === "PENDING" ?
                  properCase(t("other.lblPending")) :
                 
                  status.toUpperCase() === "AUTO ADJUSTED" ?
                  properCase(t("other.lblAutoAdjusted")) :

                  status.toUpperCase() === "AUTO COMPLETED" ?
                  properCase(t("other.lblAutoComplete")) :
                  
                  status.toUpperCase() === "IN PROGRESS" ?
                  properCase(t("other.tlinProgress")) :

                  status.toUpperCase() === "AUTO APPROVED" ?
                  properCase(t("other.lblAutoApproved")) :
                
                 status.toUpperCase() 

              ) : (
                <Link
                  title={t("pgReview.tableStaticText.btnEdit")}
                  style={{ textDecoration: "none", color:"#1b75bc" }}
                  to={pathDetails}
                  onClick={() => {
                    console.log("in link hello", data[dataIndex].inLocalTS);

                    var weekStart = moment(data[dataIndex].inLocalTS).format();
                    console.log(
                      " in Link WEEK SELECTION: weekStart: ",
                      weekStart
                    );

                    dispatch(selectedWeekOnReview({ week: weekStart }));                    
                  }}
                >
                  <Typography variant="body2">
                   {                                 
                       status &&

                       status.toUpperCase() === "APPROVED" ?                   
                       properCase(t("pgReview.tableStaticText.approved")) :
                       
                       status.toUpperCase() === "PENDING" ?
                        properCase(t("other.lblPending")) :
                       
                        status.toUpperCase() === "AUTO ADJUSTED" ?
                        properCase(t("other.lblAutoAdjusted")) :

                        status.toUpperCase() === "AUTO COMPLETED" ?
                        properCase(t("other.lblAutoComplete")) :
                        
                        status.toUpperCase() === "IN PROGRESS" ?
                        properCase(t("other.tlinProgress")) :

                        status.toUpperCase() === "AUTO APPROVED" ?
                        properCase(t("other.lblAutoApproved")) :
                      
                       status.toUpperCase() 

                                            
                    }                    
                  </Typography>
                  
                </Link>
              )}
            </>
          );
          return link;
        },
    },
  ];
  const csvConfig = mkConfig({
    fieldSeparator:',',
    decimalSeparator: '.',
    columnHeaders: [
      {
        key: "workerId",
        displayLabel: "Worker Id"
      },
      {
        key: "name",
        displayLabel: "Name"
      },
      {
        key: "jobName",
        displayLabel: "Job Role"
      },
      {
        key: "activityGroup",
        displayLabel: "Activity Group"
      },
      {
        key: "buildingId",
        displayLabel: "Building Id"
      },
      {
        key: "jobProjectInfo",
        displayLabel: "Project Info"
      },
      {
        key: "exceptionName",
        displayLabel: "Exception Type"
      },
      {
        key: "startDate",
        displayLabel: "Start Date"
      },
      {
        key: "startTime",
        displayLabel: "Start Time"
      },
      {
        key: "endDate",
        displayLabel: "End Date"
      },
      {
        key: "endTime",
        displayLabel: "End Time"
      },
      {
        key: "duration",
        displayLabel: "Duration"
      },
      {
        key: "status",
        displayLabel: "Status"
      },
    ],
    filename:'PunchReportData',
  })
  let totalDurationRef = useRef();
  let totalActivityRef = useRef();
  let totalMealRef = useRef();
  let indexArray = [];
  let mealArray = [];
  let actArray = [];
  let Tot = 0;
  let mealTotal = 0;
  let actTotal = 0;

  const handleExportData = () =>{
    let mappedRow = data.map(({workerId, name, jobName, activityGroup, buildingId, jobProjectInfo, exceptionName, startDate, startTime,
      endDate, endTime, duration, status
    })=>({workerId, name, jobName, activityGroup, buildingId, jobProjectInfo, exceptionName, startDate, startTime,
      endDate, endTime, duration, status}));
    
    // const rowData = rows.map((row) => row.original);
    console.log("rowData", mappedRow);
    
    const csv = generateCsv(csvConfig)(mappedRow);
    download(csvConfig)(csv);
  }
  // const options = {
  //   filter: true,
  //   download: true,
  //   print: false,
  //   filterType: "multiselect",
  //   responsive: "standard",
  //   selectableRows: false,
  //   onFilterChange: (columnChanged, filterList) => {
  //     //console.log("---filterList----",filterList);
  //     //console.log("----columnChanged-----",columnChanged);
  //     dispatch(saveReportViewFilterList(filterList));
  //   },
  //   setFilterChipProps: (colIndex, colName, data) => {
  //     console.log(colIndex, colName, data);
  //     return {
  //       style: { color: "#1B75BC", border: "1px solid #1B75BC" },
  //       variant: "outlined",
  //       className: "testClass123",
  //     };
  //   },

  //   onTableChange: (action, tableState) => {
  //     indexArray = [];
  //     mealArray = [];
  //     actArray = [];
  //   },

  //   // apply background color to rows with incomplete status
  //   setRowProps: (row, dataIndex, rowIndex) => {
  //     // const bgWithinRange = INCOMPLETE_BG_VALID;
  //     // const bgOutOfRange = INCOMPLETE_BG_INVALID;
  //     // if (data[dataIndex]) {
  //     //   let tempTot = parseFloat(parseFloat(data[dataIndex].duration) + Tot);
  //     //   if (data[dataIndex].activityGroup !== "Meal") {
  //     //     let tempactTot = parseFloat(
  //     //       parseFloat(data[dataIndex].duration) + actTotal
  //     //     );
  //     //     if (!actArray.includes(dataIndex)) {
  //     //       actArray.push(dataIndex);
  //     //       setActivityDuration(tempactTot);
  //     //     }
  //     //   }

  //     //   if (data[dataIndex].activityGroup == "Meal") {
  //     //     let tempMealTot = parseFloat(
  //     //       parseFloat(data[dataIndex].duration) + mealTotal
  //     //     );
  //     //     if (!mealArray.includes(dataIndex)) {
  //     //       mealArray.push(dataIndex);
  //     //       setMealDuration(tempMealTot);
  //     //     }
  //     //   }

  //     //   if (!indexArray.includes(dataIndex)) {
  //     //     indexArray.push(dataIndex);
  //     //     setTotalDuration(tempTot);
  //     //   }

  //     //   const { status, endDate, endTime, startDate, startTime } =
  //     //     data[dataIndex];
  //     //   if (!(endDate && endTime && startDate && startTime)) {
  //     //     let applyColor =
  //     //       startDate &&
  //     //       moment().diff(moment(startDate, dateConfig.format3), "days") > 14
  //     //         ? bgOutOfRange
  //     //         : bgWithinRange;
  //     //     return {
  //     //       style: { backgroundColor: applyColor },
  //     //     };
  //     //   }
  //     // }
  //     // return {};
  //   },

  //   setTableProps: () => {
  //     setTotalDuration(0);
  //     setMealDuration(0);
  //     setActivityDuration(0);
  //   },

  //   // rowsPerPage: defaultRowsPerPage,
  //   rowsPerPageOptions: defaultPaginationOptions,
  //   textLabels: getTextLabels(t),
  //   downloadOptions: { filename: "PunchReportData.csv" },
  // };

  // const setTotalDuration = (val) => {
  //   Tot = val;
  //   if (totalDurationRef.current) {
  //     totalDurationRef.current.innerText = parseFloat(Tot).toFixed(2);
  //   }
  // };
  // const setActivityDuration = (val) => {
  //   actTotal = val;
  //   if (totalActivityRef.current) {
  //     totalActivityRef.current.innerText = parseFloat(actTotal).toFixed(2);
  //   }
  // };

  // const setMealDuration = (val) => {
  //   mealTotal = val;
  //   if (totalMealRef.current) {
  //     totalMealRef.current.innerText = parseFloat(mealTotal).toFixed(2);
  //   }
  // };
  const table = useMaterialReactTable({
    columns,
    data: data,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: isLoading,
      showProgressBars: isLoading
    },
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition:'none'
        }
      },
      variant: 'determinate'
    },
    muiSkeletonProps:{
      animation:'wave',
      height: 20
    },
    enableGrouping: true,
    enableSelectAll: true,
    enablePagination: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    muiPaginationProps:{
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true
    },
    initialState: {
      density: "compact",
      pagination:{
        pageSize: 50
      }
    },
    muiTableContainerProps:{
      sx:{
        minHeight: `calc(100vh - 400px)`,
        minWidth: `calc(100vh - 220px)`
      }
    },
    renderTopToolbarCustomActions:({table}) =>{
      return (
        <Grid container style={{
          gap:"20px",
          alignItems:"flex-end",
          margin:"5px 20px 0 20px",
          justifyContent:"space-between",
        }}>
          <Typography variant="h6" sx={{color: "#58595B"}}>{properCase(t("pgReview.punchReport"))}</Typography>
          <Button
           disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={()=>
            handleExportData(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export
        </Button>
        </Grid>
      )
    },
    muiTableBodyRowProps:({row})=>{
      let dataIndex = row.index;
      const bgWithinRange = INCOMPLETE_BG_VALID;
      const bgOutOfRange = INCOMPLETE_BG_INVALID;
      if (data[dataIndex]) {
        let tempTot = parseFloat(parseFloat(data[dataIndex].duration) + Tot);
        if (data[dataIndex].activityGroup !== "Meal") {
          let tempactTot = parseFloat(
            parseFloat(data[dataIndex].duration) + actTotal
          );
          if (!actArray.includes(dataIndex)) {
            actArray.push(dataIndex);
            setActivityDuration(tempactTot);
          }
        }

        if (data[dataIndex].activityGroup == "Meal") {
          let tempMealTot = parseFloat(
            parseFloat(data[dataIndex].duration) + mealTotal
          );
          if (!mealArray.includes(dataIndex)) {
            mealArray.push(dataIndex);
            setMealDuration(tempMealTot);
          }
        }

        if (!indexArray.includes(dataIndex)) {
          indexArray.push(dataIndex);
          setTotalDuration(tempTot);
        }

        const { status, endDate, endTime, startDate, startTime } =
          data[dataIndex];
        if (!(endDate && endTime && startDate && startTime)) {
          let applyColor =
            startDate &&
            moment().diff(moment(startDate, dateConfig.format3), "days") > 14
              ? bgOutOfRange
              : bgWithinRange;
          return {
            style: { backgroundColor: applyColor },
          };
        }
      }
      return {};
    }
      // {properCase(t("pgReview.punchReport"))}
  })

  const setTotalDuration = (val) => {
    Tot = val;
    if (totalDurationRef.current) {
      totalDurationRef.current.innerText = parseFloat(Tot).toFixed(2);
    }
  };
  const setActivityDuration = (val) => {
    actTotal = val;
    if (totalActivityRef.current) {
      totalActivityRef.current.innerText = parseFloat(actTotal).toFixed(2);
    }
  };

  const setMealDuration = (val) => {
    mealTotal = val;
    if (totalMealRef.current) {
      totalMealRef.current.innerText = parseFloat(mealTotal).toFixed(2);
    }
  };
  const classes = useStyles();
  return (
    <>
      {/* {
        isLoading ? (
          <>
            <CircularProgress />
            <Typography variant="body2">
              {t("pgReview.loadingGoogleUserDetails")}
            </Typography>
          </>
        ) : 
        loadingError ? (
          <Alert severity="info">{t(loadingError)}</Alert>
        ) : null
        reportMarkup
      } */}

      {/* <div className={loadingError ? classes.hideElem : ""}> */}
          <MaterialReactTable table={table}/>
          <Card className={classes.container}>
            <span className={classes.label1}>{properCase(t("other.tlactivityHours"))}</span>
            <span className={classes.label2} ref={totalActivityRef}></span>
            <span className={classes.label1}>{properCase(t("other.tlmealHours"))}</span>
            <span className={classes.label2} ref={totalMealRef}></span>
            <span className={classes.label1}>
              {properCase(t("pgReview.totalHours"))}
            </span>
            <span className={classes.label2} ref={totalDurationRef}></span>
          </Card>
      {/* </div> */}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  hideElem: {
    display: "none",
  },
  container: {
    marginTop: 10,
    background: "#1b75bc",
    color: "white",
    fontSize: 16,
    fontWeight: "bolder",
    minHeight: 40,
    width: "100%",
    lineHeight: 3,
  },
  label1: {
    marginLeft: 80,
  },
  label2: {
    marginLeft: 30,
    width: "100%",
  },
}));

export const ts = (time) => {
  return time
    ? moment(time).format(timeConfig.format4) +
        " " +
        moment(time).format(dateConfig.format5)
    : null;
};

ReportView.propTypes = {
  month: PropTypes.any.isRequired,
  week: PropTypes.any.isRequired,
  view: PropTypes.any.isRequired,
};
export default ReportView;
